'use client';

import { useEffect, useState } from 'react';

import { floorToMinute } from './sidebar-inbox-state';

const MINUTE_MS = 60_000;

/**
 * Wall-clock time rounded down to the minute, refreshed every minute. Inbox
 * queries take it as an argument because Convex queries must not read the
 * clock; the rounding keeps the query arguments (and its cache) stable
 * between ticks.
 */
export function useMinuteClock(): number {
  const [now, setNow] = useState(() => floorToMinute(Date.now()));
  useEffect(() => {
    const interval = window.setInterval(
      () => setNow(floorToMinute(Date.now())),
      MINUTE_MS
    );
    return () => window.clearInterval(interval);
  }, []);
  return now;
}
